import Home from './pages/Home/Home';
import './App.css';

function App() {
  console.log('Loading App component');
  return (
    <div className="flex flex-col flex-grow bg-black">
       <Home />
    </div>
    
    )
}

export default App;